import { User } from "@coworker/apprestructured/src/shared/types/user";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import { StoreTeam } from "@coworker/types/lib/storeteam";

export type AssignedUserType = {
  assignedTeamId: string | null;
  assignedUserId: string | null;
};

export const UsersList = ({
  matchingUsers,
  isLoading,
  teams,
  onAssignedChange,
}: {
  matchingUsers: User[];
  isLoading: boolean;
  teams: StoreTeam[];
  onAssignedChange: (data: AssignedUserType) => void;
}) =>
  isLoading ? (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <FixaSkeleton height="70px" />
      <FixaSkeleton height="70px" />
      <FixaSkeleton height="70px" />
      <FixaSkeleton height="70px" />
    </div>
  ) : (
    <FixaListView id="coworkers">
      {matchingUsers.map((user) => (
        <FixaListViewItem
          key={user.uid}
          avatarProps={{
            text: `${user.firstName?.slice(0, 1)}${user.lastName?.slice(0, 1)}`,
            screenReaderText: user.fullName,
          }}
          inset
          emphasised
          title={user.fullName}
          description={
            teams.find((team) => team.id === user.teamId)?.name ?? ""
          }
          control="navigational"
          controlIcon={null}
          onClick={() => {
            onAssignedChange({
              assignedTeamId: user.teamId,
              assignedUserId: user.uid,
            });
          }}
        />
      ))}
    </FixaListView>
  );
